export default __webpack_public_path__ + "static/media/transport-logistics-compressed1.20e91713.jpg";